'use client';

import { useState } from 'react';
import { Shield } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RoleIconProps {
  badgeUrl?: string | null;
  color?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

// Pixel dimensions matching sizeMap classes — explicit width/height attrs prevent CLS.
const sizePxMap = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
};

export function RoleIcon({ badgeUrl, color, size = 'md', className }: RoleIconProps) {
  const [imgError, setImgError] = useState(false);
  const sizeClass = sizeMap[size];
  const sizePx = sizePxMap[size];

  if (badgeUrl && !imgError) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={badgeUrl}
        alt=""
        width={sizePx}
        height={sizePx}
        loading="lazy"
        decoding="async"
        className={cn(sizeClass, 'rounded object-cover', className)}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <Shield
      className={cn(sizeClass, className)}
      style={color ? { color } : undefined}
    />
  );
}
